// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/get/{id}
 *
 * Returns a single order detail with its items[] (each carrying its
 * attribute-value rows).
 */
import type { Orders_OrderDetailRow } from './Orders_OrderDetailRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_GetResponseDados = Orders_OrderDetailRow;

export type Orders_GetResponse = ApiResponse<Orders_GetResponseDados>;

registerResponseContract('Orders_GetResponse', {
  so_order_id:               { type: 'number',  required: true },
  so_order_client_id:        { type: 'number',  required: false },
  so_order_franchise_id:     { type: 'number',  required: true },
  so_order_location_id:      { type: 'number',  required: false },
  so_order_origin:           { type: 'string',  required: true },
  so_order_status:           { type: 'string',  required: true },
  so_order_discount_type:    { type: 'string',  required: false },
  so_order_discount_value:   { type: 'number',  required: false },
  so_order_subtotal:         { type: 'number',  required: true },
  so_order_total:            { type: 'number',  required: true },
  so_order_notes:            { type: 'string',  required: false },
  so_order_user_id:          { type: 'string',  required: true },
  so_order_created_at:       { type: 'string',  required: true },
  so_order_cancel_reason:    { type: 'string',  required: false },
  so_order_cancelled_at:     { type: 'string',  required: false },
  so_order_cancelled_by:     { type: 'string',  required: false },
  so_order_legacy_number:    { type: 'number',  required: false },
  so_order_client_name:      { type: 'string',  required: false },
  so_order_client_ddi:       { type: 'string',  required: false },
  so_order_client_ddd:       { type: 'string',  required: false },
  so_order_client_phone:     { type: 'string',  required: false },
  so_order_client_cpf:       { type: 'string',  required: false },
  so_order_total_recebido:   { type: 'number',  required: true },
  so_order_financial_status: { type: 'string',  required: true },
  so_order_franchise_name:   { type: 'string',  required: false },
  items: {
    type: 'array',
    required: false,
    items: {
      so_order_item_id:                          { type: 'number',  required: true },
      so_order_item_order_id:                    { type: 'number',  required: true },
      so_order_item_type:                        { type: 'string',  required: true },
      so_order_item_parent_item_id:              { type: 'number',  required: false },
      so_order_item_service_id:                  { type: 'number',  required: false },
      so_order_item_additional_service_id:       { type: 'number',  required: false },
      so_order_item_additional_service_price_id: { type: 'number',  required: false },
      so_order_item_priority_id:                 { type: 'number',  required: false },
      so_order_item_product_id:                  { type: 'number',  required: false },
      so_order_item_quantity:                    { type: 'number',  required: true },
      so_order_item_unit_price:                  { type: 'number',  required: true },
      so_order_item_description:                 { type: 'string',  required: false },
      so_order_item_discount_type:               { type: 'string',  required: false },
      so_order_item_discount_value:              { type: 'number',  required: false },
      so_order_item_total:                       { type: 'number',  required: true },
      so_order_item_deadline_days:               { type: 'number',  required: false },
      so_order_item_qrcode:                      { type: 'string',  required: false },
      so_order_item_franchise_id:                { type: 'number',  required: false },
      so_order_item_delivered_at:                { type: 'string',  required: false },
      so_order_item_expected_delivery_at:        { type: 'string',  required: false },
      so_order_item_created_at:                  { type: 'string',  required: true },
      so_service_name:                           { type: 'string',  required: false },
      so_priority_name:                          { type: 'string',  required: false },
      attributes: {
        type: 'array',
        required: false,
        items: {
          so_oiav_id:             { type: 'number',  required: true },
          so_oiav_order_item_id:  { type: 'number',  required: true },
          so_oiav_attribute_id:   { type: 'number',  required: true },
          so_oiav_value:          { type: 'string',  required: true },
          so_oiav_created_at:     { type: 'string',  required: true },
          so_item_attribute_name: { type: 'string',  required: true },
          so_item_attribute_type: { type: 'string',  required: true },
        },
      },
      item_display_status:                       { type: 'string',  required: false },
      step_total:                                { type: 'number',  required: false },
      step_completed:                            { type: 'number',  required: false },
      so_order_item_alerts:                      { type: 'string',  required: false },
      so_order_item_notes:                       { type: 'string',  required: false },
      so_order_item_service_label:               { type: 'string',  required: false },
    },
  },
})
